import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { projectApi } from "@/api/projectApi";

export const fetchProjects = createAsyncThunk("projects/fetchAll", () =>
  projectApi.list(),
);
export const createProject = createAsyncThunk(
  "projects/create",
  (data: {
    name: string;
    description?: string;
    startedAt?: string;
    endedAt?: string;
  }) => projectApi.create(data),
);
export const deleteProject = createAsyncThunk("projects/delete", (id: string) =>
  projectApi.remove(id).then(() => id),
);

const projectSlice = createSlice({
  name: "projects",
  initialState: { list: [] as any[], loading: false },
  reducers: {},
  extraReducers: (b) => {
    b.addCase(fetchProjects.pending, (s) => {
      s.loading = true;
    })
      .addCase(fetchProjects.fulfilled, (s, a) => {
        s.list = a.payload;
        s.loading = false;
      })
      .addCase(fetchProjects.rejected, (s) => {
        s.loading = false;
      })
      .addCase(createProject.fulfilled, (s, a) => {
        s.list.push(a.payload);
      })
      .addCase(deleteProject.fulfilled, (s, a) => {
        s.list = s.list.filter((p: any) => p.id !== a.payload);
      });
  },
});

export default projectSlice.reducer;
